import * as React from "react";

import { CircularProgress } from "@mui/material";

const Loading: React.FC = () => {
  return <CircularProgress />;
};

export default Loading;
